<!--
 * @Description  : 表格展示
-->

<template minapp="mpx" xlang="wxml">
  <view class="content-table">
    <!-- <view>{{tableValue}}</view> -->
    <view wx:if="{{tableValue.title}}" class="title">{{tableValue.title}}</view>
    <!-- ceshi -->
   <table class="main-table">
     <tbody>
      <tr>
        <th width="100px">{{tableValue.tableth[0]}}</th>
        <th>{{tableValue.tableth[1]}}</th>
      </tr>
      <tr wx:for="{{tableValue.tablelist}}" wx:key="index" class="table-content">
        <td>{{item.title}}</td>
        <td>
          <view class="label" wx:for="{{item.content}}">
            <view wx:if="{{item.submit_title}}" class="label-text">{{item.submit_title}}</view>
            <rich-text nodes="{{item.text}}"></rich-text>
            <!-- <view>二代身份证原件</view> -->
          </view>
          <!-- <view class="label">
            <view class="label-text">取票条件：</view>
            <view>车站售票窗口、车站自动售取票机、代售点</view>
          </view> -->
        </td>
      </tr>
    </tbody>
   </table>

  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      title: {
        type: String,
        value: '发车前取票方式说明'
      },
      tableValue:{
        type: Object,
        value:()=>{}
      }
    },
    data() {
      return {
        
      }
    }
  })
</script>

<style scoped lang="stylus">
  .content-table
    position static
    left 0px
    top 0px
    border-radius 8px
    opacity 1
    /* 自动布局 */
    display flex
    flex-direction column
    padding 0px
    box-sizing border-box
    /* 纯白 */
    background #FFFFFF
    z-index 0
    .title
      display flex
      height 46px
      align-items center
      margin 0 12px
      border-bottom 0.5px rgba(0, 0, 0, 0.08) solid
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      line-height 19px
      letter-spacing 0px
      color #1473FF

    .main-table
      // width: 100%;
      margin 12px 12px 0
      border-radius: 4px;
      border-collapse: collapse;
      margin-bottom: 12px;
      border-radius: 4px;
      overflow: hidden;
      th, td
        border: 1px solid #e5e5e5;
        padding: 8px 12px;
        box-sizing: border-box;
        color: #666;
        font-size: 14px;
      th
        text-align: left;
        padding: 8px 12px;
        background: rgba(231, 241, 255, 0.3);
        box-sizing: border-box;
        border-color: rgba(0, 0, 0, 0.08);
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        line-height: 16px;
        letter-spacing: 0px;
        color: #666666;
      td
        box-sizing border-box
        padding 12px
        background: #fff;
        vertical-align middle
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        line-height: 16px;
        letter-spacing: 0px;
        color: #666666;
        z-index: 1;
        .label 
          display flex
          margin-bottom 8px
          &:last-child
            margin 0
        .label-text
          width: 70px;
          float: left;
          flex-shrink 0
          white-space: nowrap;

</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>